module.exports = "<span class=\"ws-fancy-formatting ws-fancy-percent\"> <span ng-hide=isNoNumberSymbol(percentage) class=value>{{percentage | number : toFixed}}</span><sup ng-hide=isNoNumberSymbol(percentage)>%</sup><span class=value ng-show=isNoNumberSymbol(percentage) ng-bind=NO_NUMBER_SYMBOL></span> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/formatting/fancy-percent/ws-fancy-percent.tmpl.html
// module id = 56
// module chunks = 0